import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

const revealAnimations = () => {

  const sections = [...document.querySelectorAll('section')];
  const welcome = sections[0];

  const fades = [...document.querySelectorAll('[data-fade]')];
  const scrubs = [...document.querySelectorAll('[data-scrub]')];
  const staggers = [...document.querySelectorAll('[data-stagger]')];
  const scrollParallaxItems = [...document.querySelectorAll('[data-parallax-scroll]')];

  const animateScrub = (el) => {

    let type = el.dataset.scrub;

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        // toggleActions: "play none none reverse",
        // start: "top 80%",
        start: "top bottom",
        end: "top 65%",
        scrub: 2,
        // markers: true
      }
    });

    switch (type) {
      case 'in':
        tl.from(el, { autoAlpha: 0, ease: "none" });
        break;
      case 'up':
        tl.from(el, { yPercent: 50, autoAlpha: 0, ease: "none" });
        break;
      default:
        break;
    }
  }

  const animateFades = (el) => {

    let type = el.dataset.fade;

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        toggleActions: "play none none reverse",
        start: "top 80%",
        // markers: true
      }
    });

    switch (type) {
      case 'in':
        tl.from(el, { duration: 2, autoAlpha: 0, ease: "none" });
        break;
      case 'up':
        tl.from(el, { duration: 1, y: 100, autoAlpha: 0, ease: "none" });
        break;
      default:
        break;
    }
  }

  const animateStaggers = (el) => {

    let items = [...el.querySelectorAll('[data-item]')];
    if (!items.length) return;

    let type = el.dataset.stagger;
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        toggleActions: "play none none reverse",
      }
    });

    switch (type) {
      case 'fadein':
        tl.from([items], { duration: 1, autoAlpha: 0, ease: "none", stagger: 0.2 });
        break;
      case 'fadeup':
        tl.from([items], { duration: 1, autoAlpha: 0, yPercent: 50, stagger: 0.3 });
        break;
      default:
        break;
    }
  }

  const parallaxAnimation = (el) => {

    let options = JSON.parse(el.dataset.parallaxScroll);

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        scrub: 1,
        // markers: true
      }
    });

    tl.to(el, { yPercent: options?.yPercent ?? 0, y: options?.y ?? 0 })
  }

  const animateWelcome = () => {
    if (!sections[1] || sections[0].classList.contains('welcome_about') || sections[0].classList.contains('welcome_process')) return;

    ScrollTrigger.create({
      trigger: welcome,
      pin: true,
      // markers: true,
      pinSpacing: false
    });

    gsap.timeline({
      scrollTrigger: {
        trigger: sections[1],
        // markers: true,
        scrub: true,
      }
    })
      .to(welcome, { y: "-50vh" })
  }

  welcome && animateWelcome();
  fades.length && fades.forEach(el => animateFades(el));
  scrubs.length && scrubs.forEach(el => animateScrub(el));
  staggers.length && staggers.forEach(el => animateStaggers(el));
  scrollParallaxItems.length && scrollParallaxItems.forEach(el => parallaxAnimation(el));
}

export { revealAnimations }